import styles from "../../common/MobileSizeComp/MobileSize.module.scss";
import SizeGuidePopUp from "../SizeGuidePopUp";

export default function MobileSizeComp({ AddToBag, sizeGuideType }) {
  return (
    <>
      <div className={styles.dropup_wrapper}>
        {sizeGuideType && (
          <div className={styles.size_guide}>
            <SizeGuidePopUp sizeGuideType={sizeGuideType} className="xx-small" pdp={true} />
          </div>
        )}
        {AddToBag}
      </div>
    </>
  );
}
